module.exports = __webpack_public_path__ + "img/40_38_032_200.02fabd8e.jpg";